import { EnumAPPRelationshipType } from '../../../../../../api/com/MetaPattern/MDA/MD/APPModel/EnumAPPRelationshipType';
import { MenuContain } from '../../../../../../api/com/MetaPattern/MDA/MD/APPModel/MenuContain';

export class MenuContainExtend {
  public static Init(dto: MenuContain) {
    dto.aPPRelationshipType = EnumAPPRelationshipType.MenuContain;
  }
}
